module.exports = __webpack_public_path__ + "static/media/video_icon.53b1c49c.svg";